module.exports = __webpack_public_path__ + "img/antes_despues_251.73cc7f7b.png";